

exports.__esModule = true;
exports.$ThirdPartyOnboard = undefined;

var _squid = require('squid');

var $ThirdPartyOnboard = exports.$ThirdPartyOnboard = _squid.$Model.extend('$ThirdPartyOnboard', {
    api: new _squid.$Api({
        uri: '/api/third-party',
        cache: true
    })
});

angular.value("$ThirdPartyOnboard", $ThirdPartyOnboard);
_squid.$Model;

_squid.$Api;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-models/src/thirdPartyWallet/index.js
// module id = ../node_modules/xo-models/src/thirdPartyWallet/index.js
// module chunks = 0